import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY;
const ivKey = process.env.REACT_APP_IV_KEY;

export function encryptAESCryptoJS(plainText) {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(ivKey);

  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
}

export function decryptAESCryptoJS(base64Text) {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(ivKey);

  const decrypted = CryptoJS.AES.decrypt(base64Text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
